// Animation timing constants
export const ANIMATION_DURATION = 800
export const TRANSITION_DELAY = 300

// Initial interests data
export const initialInterests: Interest[] = [
  {
    id: 'actionableInsights',
    label: 'Identify investment opportunities though actionable climate and disaster insights',
    selected: false,
  },
  {
    id: 'advancedAnalytics',
    label: 'Guide planning through advanced analytics and modeling tools',
    selected: false,
  },
  {
    id: 'collaboration',
    label: 'Collaborate with experts and partners on resilience initiatives and planning',
    selected: false,
  },
  {
    id: 'evidenceBasedPolicy',
    label: 'Get support for evidence-based policy and decision-making',
    selected: false,
  },
  { id: 'fundingOpportunities', label: 'Explore funding or partnership opportunities', selected: false },
]

export const acknowledgementInfo: Interest[] = [
  {
    id: 'has_given_consent',
    label:
      'I give my consent to ADB to process and use my personal data and contact details for the Explorer immersive experience.',
    selected: false,
  },
  {
    id: 'has_agreed_to_receive_emails',
    label: 'I agree to receive email updates about the Explorer.',
    selected: false,
  },
  {
    id: 'has_given_permission_to_process_data',
    label:
      'I agree that the information submitted by me will be processed by ADB in accordance with the ADB Privacy statement as published, and as may be amended from time to time, on the ADB website Terms of Use | Asian Development Bank',
    selected: false,
  },
  {
    id: 'has_acknowledged_for_demo_showcases',
    label: 'I acknowledge that the demo showcases a prototype, and the features may not represent the final product.',
    selected: false,
  },
]
